<template>
  <div>
    <body onload="InitPage()" onbeforeunload="DeletePage()">
    <table id="MainTable1">
      <tr style="display: none;">
        <table>
          <tr>
            <td width="80">Timeout</td>
            <td>
              <select size="1" id="DDb_TimeoutOpt" onchange="TimeoutOpt()">
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5*</option>
              </select>
            </td>
          </tr>
          <tr>
            <td width="80">Brightness</td>
            <td>
              <input type="number" id=Tb_BrightnessValue min="0" max="100" value="-1"
                     style="width:100px;">
              <button type="button" id="bt_BrightnessValueup" onclick="BrightnessValueup()">
                +
              </button>
              <button type="button" id="bt_BrightnessValuedw" onclick="BrightnessValuedw()">
                -
              </button>
            </td>
          </tr>
          <tr>
            <td width="50">Sensitivity</td>
            <td>
              <input type="number" id=Tb_Sensitivity min="0" max="100" value="-1"
                     style="width:100px;">
              <button type="button" id="bt_SensitivityValueup" onclick="SensitivityValueup()">
                +
              </button>
              <button type="button" id="bt_SensitivityValuedw" onclick="SensitivityValuedw()">
                -
              </button>
            </td>
          </tr>
          <tr>
            <td width="80">FakeLevel</td>
            <td>
              <select size="1" id="DDb_FakeLevOpt" onchange="FakeLevOpt()">
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
              <label><input type="checkBox" id="Cb_EnDetectFakeAdvanced"
                            onclick="EnDetectFakeAdvancedChecked();"/>
                Ex</label>
            </td>
          </tr>
        </table>
        <table>
          <tr>
            <td style="text-align:center;">
              File Type
            </td>
            <td style="text-align:center;">
              <select size="1" id="DDb_Tftype" onchange="Tftype()">
                <option value="1">1. BMP*</option>
                <option value="2">2. 19794_4</option>
                <option value="3">3. WSQ</option>
              </select>
            </td>
          </tr>
          <tr>
            <td style="text-align:center;">
              Compression Ratio
            </td>
            <td style="text-align:center;">
              <select size="1" id="DDb_CompRatio" onchange="CompRatio()">
                <option value="0.1">0.1</option>
                <option value="0.2">0.2</option>
                <option value="0.3">0.3</option>
                <option value="0.4">0.4</option>
                <option value="0.5">0.5</option>
                <option value="0.6">0.6</option>
                <option value="0.7">0.7*</option>
                <option value="0.8">0.8</option>
                <option value="0.9">0.9</option>
                <option value="1.0">1.0</option>
              </select>
            </td>
          </tr>
        </table>
        <div>
          <h2>Matcher Options</h2>
          <p>
            <label><input type="checkBox" id="Cb_FastMode" onclick="FastModeChecked();"/>
              Fast Mode</label>
          </p>
          <p>
            Security Level
            <select size="1" id="DDb_SecuLevOpt" onchange="SecuLevOpt()">
              <option value="1">1. (FAR1/100)</option>
              <option value="2">2. (1/1,000)</option>
              <option value="3">3. (1/10,000)</option>
              <option value="4">4*.(1/100,000)</option>
              <option value="5">5. (1/1,000,000)</option>
              <option value="6">6. (1/10,000,000)</option>
              <option value="7">7. (1/100,000,000)</option>
            </select>
          </p>
          <table>
            <tr>
              <td><textarea id="Tb_Template" style="width:274px;" size="1000"></textarea></td>
            </tr>
            <tr>
              <td>
                <button id="Bt_TempDataVerify" onclick="VerifyWithTemplate();"
                        style="width:280px;height:30px;">
                  Verify Encrypted Template Data
                </button>
              </td>
            </tr>
          </table>
        </div>
        <div>
          <h2>Template Option</h2>
          <p>
            <label><input type="checkBox" id="Cb_Encrypt"
                          onclick="EncryptModeChecked();" text="bbb"/> Encrypt</label>
            with Key <input type="text" id="Txt_EncKey" size="5" maxlength="32"
                            onblur="SendParameter()"/>
            <br><font style="color : darkred;">&nbsp;&nbsp;&nbsp;&rarr;&nbsp;
            Not works for Enrollment
          </font>
          </p>
          <p>
            <label><input type="checkBox" id="Cb_ExtractEx" onclick="ExtractExModeChecked();"/>
              Use ExtractEx</label>
          </p>
          <p>
            Template Type
            <select size="1" id="DDb_Tpltype" onchange="Tpltype()">
              <option value="2001">1. SUPREMA*</option>
              <option value="2002">2. ISO_19794_2</option>
              <option value="2003">3. ANSI378</option>
            </select>
          </p>
          <p>
            Quality
            <select size="1" id="DDb_QltyLv" onchange="QltyLv()">
              <option value="1"> 1. None</option>
              <option value="2"> 2. 0</option>
              <option value="3"> 3. 10</option>
              <option value="4"> 4. 20</option>
              <option value="5"> 5. 30</option>
              <option value="6"> 6. 40*</option>
              <option value="7"> 7. 50</option>
              <option value="8"> 8. 60</option>
              <option value="9"> 9. 70</option>
              <option value="10">10. 80</option>
              <option value="11">11. 90</option>
            </select>
          </p>
          <p>
            <button id="Bt_Extract" onclick="GetTemplateData()"
                    style="width:140px;height:30px;">Get Template Data
            </button>
          </p>
        </div>
      </tr>
    </table>
    </body>
    <v-flex xs12 sm12 md12>
      <strong>Huella</strong>
      <v-divider/>
    </v-flex>
    <form action="#" name=FormHuella>
      <v-layout>
        <v-flex xs4 sm1 md1>
          <v-btn id="Bt_Init" color="primary" onclick="Init()" dark small>Init</v-btn>
        </v-flex>
        <v-flex xs4 sm1 md1>
          <v-btn id="Bt_CptSingle" color="primary"
                 v-on:click="startCaptureSingle()" dark small>Capturar
          </v-btn>
        </v-flex>
        <v-flex xs4 sm1 md1>
          <v-btn id="Bt_GtImg" color="primary"
                 v-on:click="getFingerprint()" dark small>Get Image
          </v-btn>
        </v-flex>
        <v-flex xs4 sm1 md1>
          <v-btn id="Bt_Enroll" color="primary"
                 onclick="Enroll()" dark small>Enroll
          </v-btn>
        </v-flex>
        <v-flex xs4 sm1 md1>
          <v-btn id="Bt_SbTpl" color="primary"
                 v-on:click="getFingerprintTemplate()" dark small>Template
          </v-btn>
        </v-flex>
        <v-flex xs4 sm1 md1>
          <v-btn id="Bt_DelAll" color="secundary"
                 onclick="InfoDelAll()" dark small>Borrar
          </v-btn>
        </v-flex>
        <v-flex xs4 sm1 md1>
          <v-btn id="Bt_UnInit" color="secundary"
                 onclick="UnInit()" dark small>UnInit
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm12 md12>
          <h2 id="TdAlert" style="color:blue;"></h2>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm4 md3>
          <h4>FingerPrint Live Image</h4>
          <p style="width: 94%; height: 420px; border: 1px solid lightgrey;
                  margin-right: 16px;">
            <img id="Fpimg"/>
          </p>
          <p>
            <label><input type="checkBox" id="Cb_PreviewOn"
                          onclick="PreviewOnChecked();"/>Preview On(MultiPart)</label>
          </p>
        </v-flex>
        <v-flex xs12 sm4 md3>
          <h4>Log</h4>
          <p>
                          <textarea id="Tb_DisplayLog" style="width: 94%; height: 420px;
                          border: 1px solid lightgrey; margin-right: 16px;
                          resize: none;" size="5000">
                          </textarea>
          </p>
        </v-flex>
        <v-flex xs12 sm4 md3>
          <h4>User Infomation</h4>
          <p style="width: 94%; height: 420px;
                  border: 1px solid lightgrey; margin-right: 16px;">
            <table id="UserList">
              <thead>
              <tr style="background-color: #eee;">
                <th style="background-color: black; color: white; top:-20px;">Serial</th>
                <th style="background-color: black; color: white; top:-20px;">User ID</th>
                <th style="background-color: black; color: white; top:-20px;">Template1</th>
                <th style="background-color: black; color: white; top:-20px;">Template2</th>
              </tr>
              </thead>
              <tbody></tbody>
            </table>
            <select id="slt_UserList" style="width:100%; height: 96%" size="20"
                    onchange="OnSelectUser()"></select>
          </p>
        </v-flex>
      </v-layout>
      <table style="display: none; width:340px;">
        <tr>
          <td style="vertical-align:top;">
            <p>
              <label><input type="checkBox" id="Cb_SelTemp"
                            onclick="SelTemplateModeChecked();"/> Select
                Template Mode</label>
            </p>
            <p>
              <button id="Bt_UpdateTpl" onclick="UpdateTemplate()"
                      style="width:140px;height:30px;">Update
                Selected
              </button>
              <button id="Bt_DelTpl" onclick="DelTpl()"
                      style="width:140px;height:30px;">Delete Selected
              </button>
            </p>
            <p>
              <button id="Bt_Verify" onclick="Verify();"
                      style="width:284px;height:30px;">Verify
              </button>
            </p>
            <p>
              <button id="Bt_Identify" onclick="Identify();"
                      style="width:140px;height:30px;">Identify
              </button>
              <button id="Bt_AbortIdentify" onclick="AbortIdentify();"
                      style="width:140px;height:30px;">Abort
                Identify
              </button>
            </p>
          </td>
        </tr>
      </table>
    </form>
  </div>
</template>

<script>
export default {
  name: 'biomini',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fingerPrint: this.value,
    };
  },
  methods: {
    getFingerprint() {
      GetImageBuffer((data) => {
        this.fingerPrint.fingerprint_image = data;
        this.$emit('input', this.fingerPrint);
      });
    },
    getFingerprintTemplate() {
      SaveTemplate((data) => {
        this.fingerPrint.fingerprint_template = data;
        this.$emit('input', this.fingerPrint);
      });
    },
    startCaptureSingle() {
      CaptureSingle((data) => {
        if (data) {
          PreviewOnChecked();
        }
      });
    },
  },
  beforeDestroy() {
    InfoDelAll();
    UnInit();
  },
};
</script>

<style scoped>

</style>
